import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuthApi } from "../hooks/useAuthApi";
import useApiHelper from "../hooks/useApiHelper";
import { useAuth } from "../contexts/AuthContext";

export default function useWilmaDeletedUsers() {
  const queryClient = useQueryClient();
  const { token } = useAuth();
  const { getUsers } = useAuthApi();
  const { post, put } = useApiHelper();

  const wilmaUsers = useQuery({
    enabled: !!token,
    queryKey: ["wilmaDeletedUsers"],
    queryFn: () => getUsers(token!, true),
    staleTime: 1000 * 60 * 10,
  });

  return {
    wilmaUsers
  };
}
